import React from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, TextSearchOverlayProps } from 'component/common/TextSearch/TextSearchDropdown.selectors';
import { Category, SuggestionResult } from 'core/type/SuggestionResult.types';
import TextSearchResults from 'component/common/TextSearch/TextSearchResult/TextSearchResults';
import RecentSearch from 'component/common/TextSearch/TextSearchResult/RecentSearch/RecentSearch';
import NearMe from 'component/common/TextSearch/TextSearchResult/NearMe/NearMe';
import InCitySearchKeyword from 'component/common/InCitySearchKeyword/InCitySearchKeyword';
import InCitySearchTopActivities from 'component/common/InCitySearchTopActivities/InCitySearchTopActivities';
import { MAX_RECENT_SEARCH, setRecentlySearch, transformSuggestionToRecentSearch } from 'component/common/TextSearch/suggestionUtils';
import Feature from 'component/common/Experiment/Feature';
import SearchKeywordEntryPoint from 'component/common/SearchKeywordEntryPoint/SearchKeywordEntryPoint';
import { FeatureName } from 'core/constant/FeatureName';
import { SearchEntryPointType } from 'component/common/SearchKeywordEntryPoint/SearchKeywordEntryPoint.selectors';
import { useSuggestions } from 'component/common/TextSearch/hooks/useSuggestions';

const TextSearchDropdown: React.FC<TextSearchOverlayProps> = (props) => {
    const { areSuggestionsLoading, suggestions, hasSuggestions } = useSuggestions(props.inputText);
    const onTextSearchSelect = (selected: SuggestionResult, category?: Category) => {
        props.trackTextSearchSelect(selected, props.inputText, category);
        const name = selected.name || selected.nameTranslated;
        const recentSearch = transformSuggestionToRecentSearch(selected);
        props.isSearchBoxFeatureGroup && setRecentlySearch(recentSearch, MAX_RECENT_SEARCH);
        props.handleSelectedResult(name);
        selected && props.setSelectedResult(selected, category);
        props.onClose && props.onClose();
    };

    const shouldHideRecentSearch = props.isHideRecentSearch && props.inputText !== '';

    return (
        <>
            {props.isNearByEnabled && !props.inputText.length && <NearMe handleSelectedResult={onTextSearchSelect} />}
            <Feature.On name={FeatureName.GlobalKeywordSearch}>
                {props.isInCitySearch && hasSuggestions && (
                    <SearchKeywordEntryPoint searchType={SearchEntryPointType.InCity} showPrefixIcon={true} inputText={props.inputText} cms={props.cms[316646]} />
                )}
            </Feature.On>
            <Feature.Off name={FeatureName.GlobalKeywordSearch}>{props.isInCitySearch && <InCitySearchKeyword inputText={props.inputText} />}</Feature.Off>
            {props.isSearchBoxFeatureGroup && !shouldHideRecentSearch && (
                <div data-testid="recent-search-section">
                    <RecentSearch />
                </div>
            )}
            {props.isInCitySearch && <InCitySearchTopActivities inputText={props.inputText} popularActivities={props.popularActivities} />}
            <TextSearchResults
                searchText={props.inputText}
                suggestions={suggestions}
                areSuggestionsLoading={areSuggestionsLoading}
                onSelect={onTextSearchSelect}
                popularActivities={props.popularActivities}
            />
            <Feature.On name={FeatureName.GlobalKeywordSearch}>
                {props.isGlobalKeywordSearch && hasSuggestions && (
                    <SearchKeywordEntryPoint searchType={SearchEntryPointType.Global} inputText={props.inputText} cms={props.cms[360387]} showSuffixIcon={true} />
                )}
            </Feature.On>
        </>
    );
};
TextSearchDropdown.displayName = 'TextSearchDropdown';

export default connect(mapStateToProps, mapDispatchToProps)(TextSearchDropdown);
